// eslint-disable-next-line
import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import LoginLogo from './images/ruby-logo-white.svg';

import SnackMessages from './core/SnackMessages';

// import * as coreSelectors from './core/selectors';
import * as coreActions from './core/actions';
import * as Formatters from './ui/Formatters';
import * as accountActions from './account/actions';

const styles = theme => ({
  root : {
    backgroundColor:'#102259',
    display: 'flex',
    alignItems: 'center',
    justify: 'center',
    minHeight: '100vh',
    height: 'auto',
    padding: '20px',
  },
  dialog : {
    backgroundColor:'#4395a2',
    overflow: 'auto',
    borderRadius: 25,
    color: theme.palette.primary.contrastText,
    padding: 40,
    width: 800,
  },
  /* Reverse color text field */
  reverseTextField : {
    '& input' : {
      color: 'white !important',
    },
    '& label' : {
      color: 'white !important',
    },
    '& fieldset' : {
      borderColor: 'white !important',
      borderWidth: 2,
    }
  },
  table:{
    overflow: 'auto',
    // width:'100%',
    '& th':{
        color:'white !important'
    },
    '& td':{
        color:'white !important'
    },
  },
  headerRow:{
    borderTop:"5px solid "+theme.palette.secondary.light,
  },
  money : {
    textAlign: 'right',
  },
  subtotal:{
    color:theme.palette.secondary.dark,
    fontWeight:'bold',
    textAlign: 'right',
    }
});


/*
 * Quote review screen, prior to sending them to Stripe checkout.
 */
class QuotePaymentScreen extends Component {
  constructor(props) {
    super(props);
    this.resetButtonRef = React.createRef();
  }
  
  state = {
    mobile : '',
    mobileValid : false,
    email : '',
    emailValid : false,
    running : false,
    codeSent : false,
    newQuoteFormControl:{},
    consent: false,
    checkoutUrl: null,
    token: '',
  }

  componentDidMount(){
    document.body.style.backgroundColor = '#102259';
    const queryString = window.location.hash;
    const urlParams = new URLSearchParams(queryString);
    this.fetchQuoteInfo(urlParams.get("token"));
  }
  
  fetchQuoteInfo = async (token) => {
    const response = await fetch('https://'+window.location.host+'/portalApi/api/startQuoteV2/quoteInfo?token='+token);
    const data = await response.json();
    this.setState({newQuoteFormControl:{editRecord:data.lineItems}, status: data.status,currency:data.currency,  token:token});
  }

  sendCode = () => {
    this.setState({running: true,codeSent:true});
    window.location.href = "https://"+window.location.host+"/portalApi/api/startQuoteV2/accept?token="+this.state.token;
  }

  rejectQuote = () => {
    window.location.href = "https://"+window.location.host+"/portalApi/api/startQuoteV2/cancel?token="+this.state.token;
  }

  render() {
    const { classes } = this.props;
    // For invalid tokens, kick them back right away
    if (this.state?.status === 'INVALID_TOKEN_URL') {
      return (
        <React.Fragment>
          <MuiCore.Grid container className={classes.root}
                        direction = 'column'
                        justify = 'center'
                        alignItems = 'center'>
            <MuiCore.Grid item className={classes.dialog} style={{ width: '600' }}>
              <MuiCore.Grid container spacing={1}>
                <MuiCore.Grid item xs={12} style={{ textAlign: 'center'}}>
                  <img alt=''
                       src={LoginLogo}/>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={12} style={{paddingTop: 20}}>
                  <MuiCore.Grid container align = "center" justify='center' spacing={1}>
                    <MuiCore.Grid item xs={12} >
                      <MuiCore.Typography justify='center' style={{ whiteSpace: 'pre-wrap' }}>
                        Sorry - this is not a valid quote.<br/>
                        Please contact your Account Executive for a new quote.<br/>
                      </MuiCore.Typography>
                    </MuiCore.Grid>
                    <MuiCore.Grid item xs={12}>
                      <MuiCore.Button href="https://www.ruby.com/">
                        {'Return to Ruby.com'}
                      </MuiCore.Button>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
          <SnackMessages/>
        </React.Fragment>
      );
    } else if (this.state?.status === 'PAID') {
      return (
        <React.Fragment>
          <MuiCore.Grid container className={classes.root}
                        direction = 'column'
                        justify = 'center'
                        alignItems = 'center'>
            <MuiCore.Grid item className={classes.dialog}>
              <MuiCore.Grid container spacing={1}>
                <MuiCore.Grid item xs={12} style={{ textAlign: 'center'}}>
                  <img alt=''
                       src={LoginLogo}/>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={12} style={{paddingTop: 20}}>
                  <MuiCore.Grid container align = "center" justify='center' spacing={1}>
                    <MuiCore.Grid item>
                      <MuiCore.Typography justify='center' style={{ whiteSpace: 'pre-wrap' }}>
                        This quote has been fulfilled!<br/>
                        Please contact your Account Executive if you require any additional assistance.
                      </MuiCore.Typography>
                    </MuiCore.Grid>
                    <MuiCore.Grid item xs={12}>
                      <MuiCore.Button href="https://www.ruby.com/">
                        {'Return to Ruby.com'}
                      </MuiCore.Button>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
          <SnackMessages/>
        </React.Fragment>
      );
    } else if (this.state?.status === 'CANCELLED_NOW') {
      return (
        <React.Fragment>
          <MuiCore.Grid container className={classes.root}
                        direction = 'column'
                        justify = 'center'
                        alignItems = 'center'>
            <MuiCore.Grid item className={classes.dialog}>
              <MuiCore.Grid container spacing={1}>
                <MuiCore.Grid item xs={12} style={{ textAlign: 'center'}}>
                  <img alt=''
                       src={LoginLogo}/>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={12} style={{paddingTop: 20}}>
                  <MuiCore.Grid container align = "center" justify='center' spacing={1}>
                    <MuiCore.Grid item xs={12}>
                      <MuiCore.Typography justify='center' style={{ whiteSpace: 'pre-wrap' }}>
                        This quote has been cancelled. If this was by mistake, you may still access the quote by revisiting the URL provided by your Account Executive.<br/>
                        You may contact your Account Executive to request a new quote as well.<br/>
                      </MuiCore.Typography>
                    </MuiCore.Grid>
                    <MuiCore.Grid item xs={12}>
                      <MuiCore.Button href="https://www.ruby.com/">
                        {'Return to Ruby.com'}
                      </MuiCore.Button>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
          <SnackMessages/>
        </React.Fragment>
      );
    } else if (this.state?.status === 'DISABLED' || this.state?.status === 'EXPIRED') {
      return (
        <React.Fragment>
          <MuiCore.Grid container className={classes.root}
                        direction = 'column'
                        justify = 'center'
                        alignItems = 'center'>
            <MuiCore.Grid item className={classes.dialog}>
              <MuiCore.Grid container spacing={1}>
                <MuiCore.Grid item xs={12} style={{ textAlign: 'center'}}>
                  <img alt=''
                       src={LoginLogo}/>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={12} style={{paddingTop: 20}}>
                  <MuiCore.Grid container align = "center" justify='center' spacing={1}>
                    <MuiCore.Grid item xs={12}>
                      <MuiCore.Typography justify='center' style={{ whiteSpace: 'pre-wrap' }}>
                        Sorry, this quote is no longer valid.<br/>
                        Please contact your Account Executive for a new quote.<br/>
                      </MuiCore.Typography>
                    </MuiCore.Grid>
                    <MuiCore.Grid item xs={12}>
                      <MuiCore.Button href="https://www.ruby.com/">
                        {'Return to Ruby.com'}
                      </MuiCore.Button>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
          <SnackMessages/>
        </React.Fragment>
      );
    } else if (!this.state.codeSent && this.state?.status !== 'PAID') {
      return (
        <React.Fragment>
          <MuiCore.Grid container className={classes.root}
                        direction='column'
                        justify='center'
                        alignItems='center'>

            <MuiCore.Grid item  className={classes.dialog}>
              <MuiCore.Grid container spacing={1}>
                <MuiCore.Grid item xs={12} style={{textAlign: 'center'}}>
                  <img alt=''
                       src={LoginLogo}/>
                </MuiCore.Grid>

                <MuiCore.Grid item style={{paddingTop: 20, paddingBottom: 20}}
                              xs={12}>
                  <MuiCore.Typography style={{textAlign: 'center'}}
                                      variant='h6'>
                    Please review your quote before making a payment.
                  </MuiCore.Typography>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={12} style={{overflow: 'auto'}}>
                  <MuiCore.Table className={classes.table} style={{overflow: 'auto'}}>
                    <MuiCore.TableHead>
                      <MuiCore.TableRow className={classes.headerRow}>
                        <MuiCore.TableCell>Description</MuiCore.TableCell>
                        {/*<MuiCore.TableCell>Quantity x Unit</MuiCore.TableCell>*/}
                        <MuiCore.TableCell style={{textAlign: 'right'}}>Amount</MuiCore.TableCell>
                        <MuiCore.TableCell style={{textAlign: 'right'}}>Taxes</MuiCore.TableCell>
                        <MuiCore.TableCell style={{textAlign: 'right'}}>Sub Total</MuiCore.TableCell>
                      </MuiCore.TableRow>
                    </MuiCore.TableHead>

                    <MuiCore.TableBody style={{overflowX: 'auto', overflowY: 'auto'}}>
                      {this.state.newQuoteFormControl && this.state.newQuoteFormControl.editRecord && this.state.newQuoteFormControl.editRecord.lineItems && this.state.newQuoteFormControl.editRecord.lineItems.map((line,index) => {
                        return (
                          <React.Fragment  key={line.id+line.type+''+index}>
                          <MuiCore.TableRow>
                            <MuiCore.TableCell>{line.description}</MuiCore.TableCell>
                            {/*<MuiCore.TableCell>{line.quantity}</MuiCore.TableCell>*/}
                            <MuiCore.TableCell className={classes.money}>{Formatters.formatMoney(line.debitAmount - line.discountAmount, this.state.newQuoteFormControl.editRecord.currency)}</MuiCore.TableCell>
                            <MuiCore.TableCell className={classes.money}>{Formatters.formatMoney(line.taxAmount, this.state.newQuoteFormControl.editRecord.currency)}</MuiCore.TableCell>
                            <MuiCore.TableCell className={classes.money}>{Formatters.formatMoney((line.debitAmount - line.discountAmount) + line.taxAmount, this.state.newQuoteFormControl.editRecord.currency)}</MuiCore.TableCell>
                          </MuiCore.TableRow>
                            {line.discountLineItemText && line.discountLineItemText.map((item,i) => {
                              if (item.includes('Discount will be applied as a credit to the invoice for')) {
                                return null;
                              }
                              return (<MuiCore.TableRow key={"dli-li"+index+"-r"+i}><MuiCore.TableCell colSpan={4}><MuiCore.Typography variant='caption' style={{color: '#F8D68B'}}> {item}</MuiCore.Typography></MuiCore.TableCell></MuiCore.TableRow>);
                            })}
                          </React.Fragment>);
                      })}

                      {this.state.newQuoteFormControl && this.state.newQuoteFormControl.editRecord && <MuiCore.TableRow>
                        <MuiCore.TableCell colSpan='2'></MuiCore.TableCell>
                        <MuiCore.TableCell className={classes.subtotal}>Total</MuiCore.TableCell>
                        <MuiCore.TableCell
                          className={classes.subtotal}>{Formatters.formatMoney(this.state.newQuoteFormControl.editRecord.amountTotal, this.state.newQuoteFormControl.editRecord.currency)}</MuiCore.TableCell>
                      </MuiCore.TableRow>}

                    </MuiCore.TableBody>
                  </MuiCore.Table>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={12} style={{paddingTop: 20, overflowX: 'auto', overflowY: 'auto'}}>
                  <MuiCore.Grid container justify='center' spacing={1}>
                    <MuiCore.Grid item>
                      <MuiCore.Button onClick={this.sendCode}
                                      disabled={this.props.running}>
                        Accept
                      </MuiCore.Button>
                    </MuiCore.Grid>
                    <MuiCore.Grid item>
                      <MuiCore.Button onClick={this.rejectQuote}>
                        Cancel
                      </MuiCore.Button>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
          <SnackMessages/>
        </React.Fragment>);
    } else {
      return (
        <React.Fragment>
          <MuiCore.Grid container className={classes.root}
                        direction = 'column'
                        justify = 'center'
                        alignItems = 'center'>
            <MuiCore.Grid item className={classes.dialog}>
              <MuiCore.Grid container spacing={1}>
                <MuiCore.Grid item xs={12} style={{ textAlign: 'center'}}>
                  <img alt=''
                       src={LoginLogo}/>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={12} style={{paddingTop: 20}}>
                  <MuiCore.Grid container justify = 'center' spacing={1}>
                    <MuiCore.Grid item>
                      <MuiCore.Button disabled={!this.state.resetEnabled || this.state.running}
                                      onClick={() => {}} ref={this.resetButtonRef}>
                        {this.state.running ? 'Loading Payment Screen...' : 'Quote loaded!'}
                      </MuiCore.Button>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>            
          <SnackMessages/>
        </React.Fragment>);
    }
  }
}

const mapStateToProps = (state) => {
  return ({
  });
};

const mapDispatchToProps = {
  postSnackMessage : coreActions.postSnackMessage,
  cancelPasswordReset : coreActions.cancelPasswordReset,
  sendPasswordResetCode : coreActions.sendPasswordResetCode,
  redirectToAddPayment : accountActions.redirectToAddPayment,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(QuotePaymentScreen));

